import { getConfigInfo } from '@/utils'
const item = getConfigInfo()
const subName = item ? item.subName : '系统'

export const policy = {
  operationType: [
    {
      label: '删除',
      value: -1
    },
    {
      label: '新增',
      value: 0
    },
    {
      label: '编辑',
      value: 1
    },
    {
      label: '解除负责人',
      value: 2
    }
  ],
  configApprovalStatus: [{
    label: '编辑中', value: '0'
  }, {
    label: '待审批', value: '1'
  }, {
    label: '审批通过', value: '2'
  }, {
    label: '审批驳回', value: '-1'
  }],
  settingType: [{
    label: '总部统一设置', value: '0'
  }, {
    label: '机构负责人自主设置', value: '1'
  }],
  settingDataType: [{
    label: '支付日期', value: '0'
  }],
  policyStatusList: [{
    label: '全部', value: -1
  }, {
    label: '编辑中', value: 0
  }, {
    label: '审批通过', value: 2
  }, {
    label: '待审批', value: 1
  }, {
    label: '已驳回', value: 3
  }, {
    label: '停用', value: 8
  }, {
    label: '已失效', value: 9
  }, {
    label: '等待生效', value: 10
  }, {
    label: '生效中', value: 11
  }, {
    label: '已过期', value: 12
  }, {
    label: '待接收', value: 13
  }],
  matchInsDateTypes: [{
    label: '支付日期', value: 0
  }, {
    label: '核保日期', value: 1
  }, {
    label: '签单日期', value: 2
  }, {
    label: `录入${subName}日期`, value: 3
  }, {
    label: '单证打印日期', value: 4
  }, {
    label: '录入保司系统日期', value: 5
  }],
  programStatus: [{
    label: '禁用', value: 2
  }, {
    label: '开启', value: 1
  }],
  rewardTypes: [{
    label: '一般', value: '1'
  }, {
    label: '特定', value: '2'
  }],
  schemeStatus: [{
    label: '启用', value: 1
  }, {
    label: '禁用', value: 2
  }],
  insuranceTypes: [{
    label: '商业险', value: '10'
  }, {
    label: '交强险', value: '11'
  }, {
    label: '交商同保', value: '-1'
  // }, {
  //   label: '非车险（不含随车）', value: '20'
  }],
  dateTypes: [{
    label: '支付日期', value: 8
  }, {
    label: '起保日期', value: 2
  }],
  sameToActivities: [{
    label: '同活动有效期', value: 1
  }, {
    label: '自定义', value: 0
  }],
  insuranceMethods: [
    { label: 'PC', value: '1' },
    { label: 'APP', value: '8' },
    { label: 'H5', value: '2' },
    { label: '小程序', value: '4' },
    { label: '客户通', value: '9' },
    { label: '微信', value: '10' },
    { label: '企微', value: '12' },
    { label: '电子保单', value: '13' }
  ],
  deliveryTypes: [
    { label: '直连A', value: '2' },
    { label: '直连B', value: '1' }
  ],
  recommendGetNums: [
    { label: '首单', value: '1' },
    { label: '每单', value: '2' }
  ],
  multipleList: [
    { label: '权重1', value: 1 },
    { label: '权重2', value: 2 },
    { label: '权重0.5', value: 0.5 },
    { label: '权重0', value: 0 }
  ],
  // 工作日 1 工作日，0 非工作日
  workdayList: [
    { value: '1', label: '工作日' },
    { value: '0', label: '非工作日' }
  ],
  // 权重
  timesList: [
    { value: 2, label: '权重2' },
    { value: 1.5, label: '权重1.5' },
    { value: 1, label: '权重1' },
    { value: 0.8, label: '权重0.8' }
  ],
  // 周 1 第一周，2 第二周，3 第三周，4 第四周，9 其他
  gainTimeList: [
    { value: '1', label: '第一周' },
    { value: '2', label: '第二周' },
    { value: '3', label: '第三周' },
    { value: '4', label: '第四周' },
    { value: '9', label: '第四周以后' }
  ]
}
export default {
  policy
}



// WEBPACK FOOTER //
// ./src/data/policy.js